import { useEffect, useState } from "react";
import { isNotUndefinedOrNull } from "../FunctionsCore";
export function useGoogleAdAvailability() {
    const [googleAdAvailable, setGoogleAdAvailable] = useState(false);
    useEffect(() => {
        const checkGoogleAdAvailability = () => {
            if (isNotUndefinedOrNull(window["googletag"])) {
                setGoogleAdAvailable(true);
            }
        };
        checkGoogleAdAvailability();
        window.addEventListener("load", checkGoogleAdAvailability);
        return () => {
            window.removeEventListener("load", checkGoogleAdAvailability);
        };
    }, []);
    return googleAdAvailable;
}
